import SizeGuideTwo from './SizeGuideTwo'

export { SizeGuideTwo }
